import Grid from "@mui/material/Grid";
import React from "react";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CourtIcon from "@/src/assets/icons/generic/toggleable/IconCourtDetailed";
import { useForm } from "@/src/provider/Form/FormProvider";
import { requiredValidator } from "@/src/services/validationRules";
import Group from "@/src/components/Wizard/Group";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type FinalProcessFeedbackClientProps = {
  product: AbstractCase;
};
const AdministrativeDecisionFeedbackClient = ({ product }: FinalProcessFeedbackClientProps) => {
  const { values } = useForm();

  if (!values.administrativeDecisionStatusClient || values.administrativeDecisionStatusClient === "fullyAgreed") {
    return null;
  }

  return (
    <Grid size={12}>
      <Group
        type={"radio"}
        name={"administrativeDecisionFeedbackClient"}
        question={"Wie möchten Sie jetzt weiter vorgehen?"}
        options={[
          {
            labelText: "Der Fall kann abgeschlossen werden",
            labelIcon: <CheckIcon />,
            labelIconActive: <CheckIcon active />,
            value: "accept",
            optionHintText: "Ich bin mit dem Ergebnis zufrieden oder möchte die Angelegenheit auf sich beruhen lassen.",
          },
          {
            labelText: "Ich möchte Widerspruch einlegen",
            labelIcon: <CourtIcon />,
            labelIconActive: <CourtIcon active />,
            value: "objection",
            optionHintText: "Ich akzeptiere den Bescheid nicht und möchte das behördliche Widerspruchsverfahren einleiten.",
          },
        ]}
        validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
      />
    </Grid>
  );
};
export default AdministrativeDecisionFeedbackClient;
